"use client";

import { useState } from "react";
import { MessageTimestamp } from "./MessageTimestamp";

/**
 * Assistant 메시지 하단에 붙는 액션 바 — 복사 버튼.
 * - hover 시 불투명도 상승, 평소엔 은은하게 표시
 * - text: 복사할 본문 (XML/도구 블록 제거된 prose)
 */
export function AssistantMessageActions({
  text,
  rawContent,
  createdAt,
  visible = false,
  isLatest = false,
}: {
  text: string;
  rawContent?: string;
  createdAt?: string | Date;
  visible?: boolean;
  isLatest?: boolean;
}) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    const payload = text || rawContent || '';
    if (!payload) return;
    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(payload);
      } else {
        // 비-HTTPS 환경 fallback
        const ta = document.createElement('textarea');
        ta.value = payload;
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
      }
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (e) {
      console.error('[copy]', e);
    }
  };

  return (
    <div
      role="group"
      aria-label="응답 액션"
      className={`flex items-center gap-1 mt-2 -ms-1.5 transition-opacity duration-200 ${
        visible || isLatest
          ? 'pointer-events-auto opacity-100'
          : 'pointer-events-none opacity-0 focus-within:pointer-events-auto focus-within:opacity-100'
      }`}
    >
      <button
        type="button"
        onClick={handleCopy}
        aria-label={copied ? '복사됨' : '응답 복사'}
        title={copied ? '복사됨' : '복사'}
        className="flex items-center justify-center h-8 w-8 cursor-pointer rounded-lg text-gray-500 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-100 transition-colors"
      >
        {copied ? (
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <polyline points="20 6 9 17 4 12" />
          </svg>
        ) : (
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
            <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
          </svg>
        )}
      </button>
      <span className={`overflow-hidden transition-all duration-200 ${isLatest && !visible ? 'max-w-0 opacity-0' : 'max-w-32 opacity-100'}`}>
        <MessageTimestamp createdAt={createdAt} />
      </span>
    </div>
  );
}
